// 商品路由
const name = '報表'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/shopadmin/statistics',
  component: Layout,
  children: [
    {
      path: 'distributordata',
      name: `店鋪統計`,
      component: () => import('@/view/mall/datacube/distributordata')
    },
    // {
    //   path: 'accountingStatistics',
    //   name: `店鋪分賬統計`,
    //   component: () => import( '@/view/mall/splitbill/storeAccount' )
    // },
    {
      path: 'accountingStatistics',
      name: `店鋪分賬統計`,
      meta: {
        title: `分賬統計`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-accountingStatistics" */ '@/view/mall/datacube/accountingstatistics'
        ),
      children: [
        {
          path: 'detail/:itemId?',
          meta: {
            title: `分賬統計-檢視`
          },
          component: () =>
            import(
              /* webpackChunkName: "companydata-accountingStatistics-detail" */ '@/view/mall/datacube/accountingstatistics_detail'
            )
        }
      ]
    },
    {
      path: 'cashRecord',
      name: `提款記錄`,
      component: () => import('@/view/mall/datacube/cashrecord')
    },
    // {
    //   path: 'accountingStatistics',
    //   name: `accountingStatistics`,
    //   component: () =>import('@/view/mall/splitbill/storeAccount')
    // },
    {
      path: 'financial/settlement/summary',
      name: `結算彙總`,
      component: () => import('@/view/financial/settlement/summary'),
      children: [
        {
          path: 'detail/:id?',
          component: () => import('@/view/financial/settlement/detailed')
        }
      ]
    }
  ]
}
